import { Trans } from "@lingui/react/macro";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

type AdsBetaBadgeProps = {
  className?: string;
};

export function AdsBetaBadge({ className }: AdsBetaBadgeProps) {
  return (
    <Badge variant="sidebar" className={cn("shrink-0", className)}>
      <Trans>Beta</Trans>
    </Badge>
  );
}
